import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, Signal, computed, input } from '@angular/core';

@Component({
    selector: 'unified-ui-loader',
    standalone: true,
    imports: [NgClass],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
    public readonly width = input(70);
    public readonly isLoading = input(false);
    public readonly loadingText = input('');
    public height: Signal<number> = computed(() => {
        const ratio = 1.59;
        return this.width() / ratio;
    });
}
